import React from 'react';
import styles from './BroadcastNotificationDetails.module.scss';
import Button from '../../../../../../common/ekedc-components/button/Button';

interface BroadcastNotificationContext {
    title?: string;
    message?: string;
    body?: string;
    addButton?: boolean;
    buttonLabel?: string;
    buttonLinkScreen?: string;
    addImage?: boolean;
    image?: string;
}

interface BroadcastNotificationDetailsProps {
    context: BroadcastNotificationContext;
}

const BroadcastNotificationDetails: React.FC<BroadcastNotificationDetailsProps> = ({ context }) => {
    const hasButton = context.addButton && !!context.buttonLabel;
    const bodyText = context.body || context.message;

    return (
        <div className={styles.container}>
            {bodyText && <p className={styles.body}>{bodyText}</p>}

            {hasButton && (
                <div className={styles.btnContainer}>
                    <Button text={context.buttonLabel} onClick={context.buttonLinkScreen ? () => { window.location.href = context.buttonLinkScreen!; } : undefined} />
                </div>
            )}
        </div>
    );
};

export default BroadcastNotificationDetails;
